import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Button,
  Row,
  Col
} from "shards-react";
import {Events, Store} from "../../flux";

const LIMITS = {
  idx: 0,
  levels: [5, 10, 25, 100]
};
  class RecentOnboarding extends React.Component {
    constructor(props) {
      super(props);

      this.onDataChanged = this.onDataChanged.bind(this);
      this.state = { applications: [], limitIndex: 0};
    }

    componentDidMount() {
      Store.resetDatasetListener(this.onDataChanged, true);
      Store.resetEmitter(true, Events.USERDATA, this.onDataChanged);
      this.onDataChanged();
    }

    componentWillUnmount() {
      Store.resetDatasetListener(this.onDataChanged, false);
      Store.resetEmitter(false, Events.USERDATA, this.onDataChanged);
    }

    onDataChanged() {
      const { dataget } = this.props;
      const applications = dataget() || [];
      this.setState({applications})
    }

    generateLink(app) {
      if(app.applicationID) {
        return (
          <>
            " | "
            <a className="text-info"
               href={(process.env.REACT_APP_BASENAME || "") + "/a/" + app.applicationID}>
              created application
            </a>
          </>
      );
      }
    }

    render() {
      const { applications, limitIndex } = this.state;

      return (
      <Card small className="blog-comments">
        <CardHeader className="border-bottom">
          <h6 className="m-0">{this.props.title}</h6>
        </CardHeader>

        <CardBody className="p-0">
          {applications.slice(0, LIMITS.levels[limitIndex]).map((app, idx) => (
            <div key={idx} className="blog-comments__item d-flex p-3">

              {/* Content */}
              <div className="blog-comments__content">
                {/* Content :: Title */}
                <div className="blog-comments__meta text-mutes">
                {`${(idx+1)}. `}
                  {/* <i className="material-icons">edit</i>{" "} */}
                  <a className="text-info" href={(process.env.REACT_APP_BASENAME || "")+"/r/"+app.profileID}>

                    {[app.firstName, app.lastName, ' | ', app.email].join(' ')}
                  </a>
                  {" step "}

                  {app.onboardingState}

                  {" - "}
                  <span className="text-mutes">  {app.updatedAt}</span>

                  {this.generateLink(app)}

                </div>

              </div>
            </div>
          ))}
        </CardBody>

        {
          (limitIndex<LIMITS.levels.length-1) && (LIMITS.levels[limitIndex] < applications.length) &&
            (<CardFooter className="border-top">
            <Row>
              <Col className="text-center view-report">
                <Button theme="white" type="submit" onClick={()=>{
                  this.setState({limitIndex: (this.state.limitIndex+1)%LIMITS.levels.length})
                }}>
                  Show more
                </Button>
              </Col>
            </Row>
          </CardFooter>
          )
        }

        {
          (
            (limitIndex===LIMITS.levels.length-1) ||
            (LIMITS.levels[limitIndex] >= applications.length && limitIndex>0) ||
            (applications.length===0)
          ) &&
          (<CardFooter className="border-top">
          <Row>
            <Col className="text-center view-report">
              <Button theme="white" type="submit" onClick={()=>{
                this.setState({limitIndex: 0})
              }}>
                {
                  (applications.length>0) ? "Show less" : "No records"
                }

              </Button>
            </Col>
          </Row>
          </CardFooter>
          )
        }

      </Card>
      )
    };
  }

export default RecentOnboarding;
